// extracted by mini-css-extract-plugin
export default {"content":"Statuses_content__PM3L6","header":"Statuses_header__3xSQs","item":"Statuses_item__STgDF","color":"Statuses_color__lSpKR"};